<template>
<div class="home">
  <load-screen v-if="loadStatus !== 'LOAD_SUCCESS'" :message="'Henter data ...'" />
  <grid v-if="loadStatus === 'LOAD_SUCCESS'">
    <content-area>
      <transition name="fadeup">
        <result v-if="result" :value="result.result" :labels="labels" />
      </transition>
      <transition name="fadeup">
        <question v-if="question" :item="question" :labels="labels" :show-intro="!isAkFound" :path="summaryPath" @option-click="optionSelect" />
      </transition>
      <transition name="fadeup">
        <category-selector v-if="summary.length === 0" :label="labels['category-selector-label']" @item-click="setAk" />
      </transition>
    </content-area>
    <sidebar :header="labels['summary']">
      <summary-list :items="summary" :labels="labels" @item-click="summarySelect" @reset-click="summaryReset"/>
    </sidebar>
  </grid>
</div>
</template>

<script>
import LoadScreen from './LoadScreen.vue'
import Grid from './Grid.vue'
import ContentArea from './ContentArea.vue'
import SummaryList from './SummaryList.vue'
import Sidebar from './Sidebar.vue'
import Question from './Question.vue'
import CategorySelector from './CategorySelector.vue'
import Result from './Result.vue'
import {
  mapGetters,
  mapActions
} from 'vuex'
export default {
  name: 'Home',
  components: {
    'load-screen': LoadScreen,
    'grid': Grid,
    'content-area': ContentArea,
    'summary-list': SummaryList,
    'sidebar': Sidebar,
    'question': Question,
    'category-selector': CategorySelector,
    'result': Result
  },
  mounted () {
    this.loadData()
  },
  watch: {
    summaryPath (newVal) {
      if (newVal.length > 0) {
        this.$ga.page(window.location.pathname + newVal)
      }
    }
  },
  computed: {
    ...mapGetters([
      'loadStatus',
      'tree',
      'labels',
      'question',
      'result',
      'summary'
    ]),
    isAkFound () {
      const matches = this.summary.filter((item) => {
        return item.result
      })
      return matches.length !== 0
    },
    summaryPath () {
      const items = this.summary.map((item) => {
        if (item.result) {
          return item.result
        } else if (item.question) {
          return item.question.label + '/' + item.option.label
        }
      })
      return items.join('/')
    }
  },
  methods: {
    ...mapActions({
      loadData: 'loadData',
      optionSelect: 'optionSelect',
      summarySelect: 'summarySelect',
      setAk: 'setAk',
      summaryReset: 'summaryReset'
    })
  }

}
</script>

<style scoped lang="scss">
.fadeup-enter-active {
  transition: opacity 500ms, transform 500ms;
}
.fadeup-enter {
  transform: translateY(50px);

  opacity: 0;
}
.fadeup-leave {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue